import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { isAzureAuthenticatedGuard } from 'src/lib/guards/authenticatedAzure.guard';
import { isPowerBIAuthenticatedGuard } from 'src/lib/guards/authenticatedPowerBI.guard';
import { isNotBetaGuard } from 'src/lib/guards/isNotBeta.guard';
import { metricsGuard } from 'src/lib/guards/metrics.guard';
import { uiGuard } from 'src/lib/guards/ui.guard';
import { FailComponent } from './pages/fail/fail.component';
import { LoginComponent } from './pages/login/login.component';
import { isAuthenticatedGuard } from '../lib/guards/authenticated.guard'; 
import { isAuthorizedGuard } from '../lib/guards/authorized.guard'; 
import { HomeComponent } from './pages/home/home.component';
import { SupportComponent } from './support/support.component';
import { v4Guard } from '@lib/guards/v4.guard';

const routes: Routes = [
	{path: '', canActivateChild: [uiGuard, metricsGuard], children: [
		
		{path: '', data: {title: 'Accueil'}, canActivate: [v4Guard, isAuthenticatedGuard], canActivateChild: [v4Guard], component: HomeComponent, children: [
            {path: '', pathMatch: 'full', component: HomeComponent},
            {path: 'home', component: HomeComponent, children: [
                {path: ':slug', component: HomeComponent}
            ]}
        ]},

		{path: 'fail', data: {title: 'Erreur'}, component: FailComponent, children: [
			{path: ':errorCode', component: FailComponent}
		]},
		
		{path: 'aide', data: {title: 'Aide'}, component: SupportComponent},
		
        {path: 'login', data: {title: 'Connexion'}, component: LoginComponent},

        {path: 'leave/:where', canActivate: [isAuthenticatedGuard],
            loadChildren: () => import('./pages/leave/leave.module').then(m => m.LeaveModule)},
		
		{path: 'profile', data: {title: 'Profil'},
			loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)},
	
		{path: 'demandes', data: {title: 'Demandes'}, canActivate: [isAuthenticatedGuard], 
			loadChildren: () => import('./demandes/demandes.module').then(m => m.DemandesModule)},
		
		{path: 'labo', data: {title: 'Documentation'}, canActivate: [isAuthenticatedGuard], canActivateChild: [isAuthenticatedGuard],
			loadChildren: () => import('./pages/labo/labo.module').then(m => m.LaboModule)},
	
		{path: 'bi', data: {title: 'BI'}, 
			canActivate: [isAuthenticatedGuard, isNotBetaGuard, isPowerBIAuthenticatedGuard], 
			canActivateChild: [isAuthenticatedGuard, isNotBetaGuard, isPowerBIAuthenticatedGuard], 
			loadChildren: () => import('./bi/bi.module').then(m => m.BiModule)},
		
		{path: 'drive', data: {title: 'Documents'}, 
			canActivate: [isAuthenticatedGuard, isNotBetaGuard, isAzureAuthenticatedGuard], 
			canActivateChild: [isAuthenticatedGuard, isNotBetaGuard, isAzureAuthenticatedGuard], 
			loadChildren: () => import('./drive/drive.module').then(m => m.DriveModule)},
	
		{path: 'manage', data: {title: 'Gestion'}, canActivate: [isAuthenticatedGuard, isAuthorizedGuard], canActivateChild: [isAuthenticatedGuard, isAuthorizedGuard],
			loadChildren: () => import('./manage/manage.module').then(m => m.ManageModule)},
		
        {path: 'search', data: {title: 'Rechercher'}, canActivate: [isAuthenticatedGuard], canActivateChild: [isAuthenticatedGuard],
			loadChildren: () => import('./pages/search/search.module').then(m => m.SearchModule)},

		{path: 'administration', canActivate: [isAuthenticatedGuard, isAuthorizedGuard], canActivateChild: [isAuthenticatedGuard, isAuthorizedGuard], 
			loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule)},
	
		{path: 'rh', canActivate: [isAuthenticatedGuard], canActivateChild: [isAuthenticatedGuard],
			loadChildren: () => import('./rh/rh.module').then(m => m.RhModule)},
	
		{path: 'tp', canActivate: [v4Guard, isAuthenticatedGuard, isAuthorizedGuard], canActivateChild: [v4Guard, isAuthenticatedGuard, isAuthorizedGuard], 
			loadChildren: () => import('./tp/tp.module').then(m => m.TpModule)},
	
        {path: 'sante', canActivate: [v4Guard, isAuthenticatedGuard, isAuthorizedGuard], canActivateChild: [v4Guard, isAuthenticatedGuard, isAuthorizedGuard], 
            loadChildren: () => import('./sante/sante.module').then(m => m.SanteModule)},
	
		{path: 'medico-social', canActivate: [isAuthenticatedGuard, isAuthorizedGuard], canActivateChild: [isAuthenticatedGuard, isAuthorizedGuard], 
			loadChildren: () => import('./medicosocial/medicosocial.module').then(m => m.MedicoSocialModule)},
			
		{path: 'flow', data: {title: 'Outils'}, canActivate: [isAuthenticatedGuard, isAuthorizedGuard], canActivateChild: [isAuthenticatedGuard, isAuthorizedGuard],
			loadChildren: () => import('./pages/flow/flow.module').then(m => m.FlowModule)},

        {path: 'communication-generale', data: {title: 'Communications Génerale'}, canActivate: [isAuthenticatedGuard],
            loadChildren: () => import('./pages/communication-generale/communication-generale.module').then(m => m.CommunicationGeneraleModule)},

        {path: 'communication-tools', data: {title: 'Outils de communication'}, canActivate: [isAuthenticatedGuard],
            loadChildren: () => import('./pages/communication-tools/communication-tools.module').then(m => m.CommunicationToolsModule)},

		{path: 'medico-social-fiches-signalement', data: {title: 'Fiches de signalement du Médico-Social'},
            loadChildren: () => import('./medicosocial/medicosocial.module').then(m => m.MedicoSocialModule)},

        {path: "workers", canActivate: [v4Guard], component: HomeComponent},

        {path: "4", canActivate: [v4Guard], canActivateChild: [v4Guard], component: HomeComponent, children: [
            {path: '**', canActivate: [v4Guard], canActivateChild: [v4Guard], component: HomeComponent}
        ]},

		{path: '**', redirectTo: '/fail/404'}
	]}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		paramsInheritanceStrategy: 'always'
	})],
	exports: [RouterModule]
})
export class AppRoutingModule { }